<template>
    <b-modal
        id="dashboard-show-portfolio-grade-modal"
        v-model="modal"
        :title="$t('common.title')"
        :ok-only="assignments.length === 1"
        @ok="gradeAssignment"
        :ok-title="assignments.length > 1 ? $t('common.title') : $t('common.close')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal">
        <div class="grade-check-in-progress">
            <div
                class="grade-check-completed description"
                v-if="assignments.length === 1">
                {{ $t('portfolio.no_assignments_found_to_grade_at_this_moment') }}
            </div>

            <div
                class="description"
                v-else>
                {{ $t('portfolio.choose_an_assignment_to_grade_from_the_list_below') }}
            </div>

            <div
                class="errors"
                v-if="hasError">
                <b-alert
                    show
                    variant="danger"
                    >{{ $t('portfolio.you_have_not_selected_an_assignment_yet') }}</b-alert
                >
            </div>

            <b-form-select
                class="apprentice-primary-select assignment-select"
                v-model="assignment"
                v-if="assignments.length > 1"
                :options="assignments"
                value-field="id"
                text-field="name">
            </b-form-select>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-dashboard-show-portfolio-grade-modal-component',
    data() {
        return {
            modal: false,
            canGrade: false,
            assignments: [],
            assignment: null,
            hasError: false,
        };
    },
    methods: {
        show(assignments) {
            this.assignments = [
                {
                    id: null,
                    name: this.$t('portfolio.select_an_assignment'),
                },
                ...assignments,
            ];
            this.modal = true;
            this.hasError = false;
        },

        gradeAssignment(bvModalEvt) {
            if (this.assignments.length > 1) {
                if (this.assignment === null) {
                    this.hasError = true;
                    bvModalEvt.preventDefault();
                    return;
                }

                const pos = this.assignments.map((assignment) => assignment.id).indexOf(this.assignment);
                window.location.href =
                    this.routes.assignmentShow(this.assignments[pos].id, this.assignments[pos].project_id) +
                    '?evaluate=1&evaluate_type=2';
            }
        },
    },
};
</script>

<style scoped lang="scss">
.description {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    color: $text-muted-color;
}

.assignment-select {
    width: 100%;
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .assignment-select {
        width: 250px;
    }
}
</style>
